// extracted by mini-css-extract-plugin
export default {"card":"Face2_card__N563k"};